import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Breadcrumbs, Reveal, SectionHeader, PrimaryButton } from "../components/common";
import { SERVICE_GROUPS } from "../data/site";

export default function Services() {
  return (
    <>
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Services" }]} />
      <section className="container-page py-12 lg:py-16">
        <span className="eyebrow">Services Overview</span>
        <h1 className="mt-4 max-w-3xl font-heading text-[34px] font-800 leading-[1.1] text-brand-ink md:text-[52px]">Human-led documentation and business support across five practice areas.</h1>
        <p className="mt-4 max-w-2xl text-[17px] text-brand-muted md:text-[18px]">Explore grouped services below. Exact sub-services are editable and subject to capability confirmation.</p>
      </section>

      <section className="pb-24">
        <div className="container-page grid gap-12">
          {SERVICE_GROUPS.map((g, gi) => (
            <Reveal key={g.group} delay={gi % 3}>
              <div className="rounded-3xl border border-brand-border bg-white p-8 lg:p-10">
                <SectionHeader eyebrow={`Group ${gi + 1}`} title={g.group} />
                <div className="mt-8 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
                  {g.items.map((it) => (
                    <Link key={it.title} to={`/services/${it.slug}`} className="group flex items-center justify-between gap-3 rounded-xl border border-brand-border bg-brand-bg px-5 py-4 transition-colors hover:border-brand-primary/40 hover:bg-brand-alt" data-testid={`service-link-${it.slug}`}>
                      <span className="text-[15px] font-500 text-brand-ink">{it.title}</span>
                      <ArrowRight className="h-4 w-4 text-brand-primary transition-transform group-hover:translate-x-1" />
                    </Link>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-brand-evergreen py-16 text-white">
        <div className="container-page flex flex-col items-start justify-between gap-6 lg:flex-row lg:items-center">
          <div><h2 className="font-heading text-[28px] font-800 md:text-[36px]">Not sure which service fits?</h2><p className="mt-2 text-white/70">Tell us your workflow and we will recommend a practical approach.</p></div>
          <PrimaryButton to="/contact" testid="services-cta" className="!bg-brand-gold !text-brand-evergreen hover:!bg-[#c2942f]">Discuss a Project</PrimaryButton>
        </div>
      </section>
    </>
  );
}
